import React from 'react';

class ValueOptionsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelection = this.handleSelection.bind(this);
  }

  handleSelection(e) {
    this.props.onChange({ value: e.target.value });
  }

  render() {
    const { field, valueOptions, value } = this.props;
    const labelText =
      I18n.t('smart_groups.create_modal.select_a') + ' ' + field.humanName;
    return (
      <select
        className="Rule-select"
        onChange={this.handleSelection}
        value={value || ''}
        aria-label={labelText}
      >
        <option disabled value="">
          {t('smart_groups.create_modal.select_a')} {field.humanName}
        </option>
        {valueOptions.map(valueOption => (
          <option key={valueOption.value} value={valueOption.value}>
            {valueOption.name}
          </option>
        ))}
      </select>
    );
  }
}

export default ValueOptionsDropdown;
